import { createI18n } from "vue3-i18n";
let lang = localStorage.getItem('selectedLang') || 'fr'
lang = lang != '' ? lang : 'fr'
const i18n = createI18n({
  locale: lang,
  messages: {
    fr: require("@/i18n/fr.json"),
    en: require("@/i18n/en.json"),
    ar: require("@/i18n/ar.json")
  },
});



export default i18n;



